export const Variables ={
  // API_URL: "https://apigazelle.vision-more.com/api/",
  // API_PUBLISHED: "https://apigazelle.vision-more.com/Uploads/",
  // AIRWAY_BILL:"https://apigazelle.vision-more.com/Uploads/LabelURL/"

  API_URL: "https://api.gazellebyrasha.com/api/",
  API_PUBLISHED: "https://api.gazellebyrasha.com/Uploads/",
  AIRWAY_BILL:"https://api.gazellebyrasha.com/Uploads/LabelURL/"
};
